import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 16,
	viewBox: "0 0 10 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.439462 6.91138C-0.146324 7.49717 -0.146324 8.44691 0.439462 9.0327C0.543436 9.13667 0.658876 9.22219 0.781712 9.28926L7.05311 15.5607C7.6389 16.1464 8.58865 16.1464 9.17443 15.5607C9.76022 14.9749 9.76022 14.0251 9.17443 13.4393L3.66429 7.92919L8.92474 2.66874C9.51053 2.08295 9.51053 1.13321 8.92474 0.547419C8.33896 -0.0383681 7.38921 -0.0383681 6.80342 0.547419L0.439462 6.91138Z",
		fill: "#414149"
	})
});
export { SvgChevronLeft as ReactComponent };
